import axios from 'axios';
// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法    https://www.nays.com.cn//center  https://mall.nays.com.cn/center
// const baseUrl = 'https://www.nays.com.cn/center
 // 科海线上
const baseUrl = 'https://www.nays.com.cn/center' 
// 迅有测试服务器
// const baseUrl = 'http://39.98.76.44:28081/center/'
// 本地测试
// const baseUrl = 'http://192.168.0.148:28081/center'

// const baseUrl = 'http://39.98.76.44:7000/center'

// 348mktkb.dongtaiyuming.net



const req = (method, url, params) => {
    return axios({
        method: method,
        url: baseUrl + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

// 通用公用方法
const mapbaseUrl = 'https://restapi.amap.com/v3'
const mapreq = (method, url, params) => {
    return axios({
        method: method,
        url: mapbaseUrl + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

// 支付公用方式
const alipayReq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'multipart/form-data',
            // token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        // transformRequest: [
        //     function (data) {
        //         let ret = ''
        //         for (let it in data) {
        //             ret +=
        //                 encodeURIComponent(it) +
        //                 '=' +
        //                 encodeURIComponent(data[it]) +
        //                 '&'
        //         }
        //         return ret
        //     }
        // ]
    }).then(res => res.data);
};
const alipayReqjson = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
            // token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        // transformRequest: [
        //     function (data) {
        //         let ret = ''
        //         for (let it in data) {
        //             ret +=
        //                 encodeURIComponent(it) +
        //                 '=' +
        //                 encodeURIComponent(data[it]) +
        //                 '&'
        //         }
        //         return ret
        //     }
        // ]
    }).then(res => res.data);
};

const reqGet = (method, url, params) => {
    let ret = ''
    for (let it in params) {
        ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(params[it]) +
            '&'
    }
    return axios({
        method: method,
        url: baseUrl + url + `?${ret}`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [  // 这个更改请求参数只能作用与 put post 和PATCH请求方法
             (data)=> {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

const jsonReq = (method, url, params) => {
    return axios({
        method: method,
        url: baseUrl + url,
        headers: {
            'Content-Type': 'application/json',
            // token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
    }).then(res => res.data);
};

export {
    loginreq,
    req,
    mapreq,
    alipayReq,
	alipayReqjson,
    reqGet,
    jsonReq,
	baseUrl
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js